
import { motion, useInView } from "motion/react";
import { useRef } from "react";
import { useNavigate } from "react-router";
import styled from "styled-components";

const Container = styled.div`
    background-color: var(--white);
    min-height: 80vh;

    display: flex;
    flex-direction: column;
    justify-content: center;
    /* padding: 15rem 0rem; */

    .row {
        position: relative;
        display: flex;
        height: 12rem;
        width: 75%;
        border-radius: 12.125rem;
        /* justify-content: center; */
        align-items: center;
        padding: 5rem;
        overflow: visible;
        cursor: pointer;

        &:nth-child(1) {
            align-self: flex-end;
            background-color: var(--magenta);
            border-top-right-radius: 0;
            border-bottom-right-radius: 0;

            img {
                left: -100px;
            }

            @media (max-width: 1000px) {
                img {
                    left: -70px;
                    height: 12rem;
                }
            }
        }

        &:nth-child(2) {
            align-self: flex-start;
            background-color: var(--lemonade);
            border-top-left-radius: 0;
            border-bottom-left-radius: 0;
            justify-content: flex-end;

            img {
                right: -4rem;
                bottom: -1rem;
                height: 22rem;
            }

            @media (max-width: 1000px) {
                h2 {
                    margin-right: 40px;
                }

                img {
                    right: -2rem;
                    height: 15rem;
                }
            }
        }

        &:nth-child(3) {
            align-self: flex-end;
            background-color: var(--cyan);
            border-top-right-radius: 0;
            border-bottom-right-radius: 0;

            img {
                left: -100px;
                bottom: -100px;
                height: 17rem;
            }

            @media (max-width: 1000px) {
                img {
                    bottom: -20px;
                    left: -90px;
                    height: 14rem;
                }
            }
        }

        h2 {
            text-transform: uppercase;
            color: var(--white);
            font-family: "Professor Marbles 3 LV";
            font-size: 4.5rem;
            line-height: 4rem;
            margin-top: 1rem; // A fonte é desalinhada por padrão, tem que colocar margin pra alinhar
        }

        img {
            position: absolute;
            height: 15rem;
            bottom: -10px;
            z-index: 2;
        }
    }

    @media (max-width: 1000px) {
        .arrow-container {
            display: none;
        }
        .row {
            padding: 0 3rem;
        }
        h2 {
            font-size: 2.8rem !important;
        }
    }
`;

const ArrowContainer = styled.div`
    display: flex;
    align-items: center;
    /* gap: -20px; */

    svg:nth-child(1) {
        height: 1.5rem;
    }

    svg:nth-child(2) {
        opacity: 0.6761;
        height: 1rem;
        left: -0.9rem;
    }

    svg:nth-child(3) {
        opacity: 0.3641;
        left: -1.95rem;
        height: 0.9rem;
    }

    svg {
        position: relative;
    }

    /* gap: .25rem; */
`;

const Arrow = () => {
    return (
        <ArrowContainer className="arrow-container">
            <svg
                width="31"
                height="45"
                viewBox="0 0 31 45"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M30.7309 22.4273L1.45007 44.9659L0.681325 0.924427L30.7309 22.4273Z"
                    fill="white"
                />
            </svg>
            <svg
                width="31"
                height="45"
                viewBox="0 0 31 45"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M30.7309 22.4273L1.45007 44.9659L0.681325 0.924427L30.7309 22.4273Z"
                    fill="white"
                />
            </svg>

            <svg
                width="31"
                height="45"
                viewBox="0 0 31 45"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M30.7309 22.4273L1.45007 44.9659L0.681325 0.924427L30.7309 22.4273Z"
                    fill="white"
                />
            </svg>
        </ArrowContainer>
    );
};

export const WhiteSection = () => {
    const ref = useRef(null);
    const isInView = useInView(ref, { margin: "200px", once: true });
    const navigateTo = useNavigate();
    return (
        <Container ref={ref}>
            <motion.div
                animate={{ x: isInView ? 0 : "150vw" }}
                transition={{ duration: 1 }}
                className="row"
                onClick={() => {
                    window.location.href = "/festas";
                }}
            >
                <h2>
                    Comemore seu <br />
                    Aniversário
                </h2>
                <Arrow />
                <motion.img
                    initial={{ opacity: 0, x: -200 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ delay: 1.5 }}
                    src="/white-section/smurf-1.png"
                ></motion.img>
            </motion.div>
            <motion.div
                animate={{ x: isInView ? 0 : "-150vw" }}
                transition={{ duration: 1, delay: 0.5 }}
                className="row"
                onClick={() => {
                    navigateTo("/atracoes");
                }}
            >
                <h2>Nossas atrações</h2>
                <Arrow />
                <motion.img
                    initial={{ opacity: 0, x: -200 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ delay: 2 }}
                    src="/white-section/smurf-4.png"
                ></motion.img>
            </motion.div>
            <motion.div
                animate={{ x: isInView ? 0 : "150vw" }}
                transition={{ duration: 1, delay: 1 }}
                className="row"
                onClick={() => {
                    navigateTo("/redes-sociais");
                }}
            >
                <h2>
                    Siga nossas
                    <br />
                    Redes Sociais
                </h2>
                <Arrow />
                <motion.img
                    initial={{ opacity: 0, x: -200 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ delay: 2.5 }}
                    src="/white-section/smurf-3.png"
                ></motion.img>
            </motion.div>
        </Container>
    );
};
